import { PartialId } from '@attain-apps/string-builder'

import * as core from '../../../../../../core'

export const RESOURCE = {
  payload: {
    description:
      'Contains Award PI: The association(s) between principal investigator (PI) and award. A PI may oversee multiple awards or share an award with other PIs.',
    name: 'Award PIs',
    partialId: PartialId.Standard.create('award_pis'),
  },
  type: core.quiver.Resource.Type.DmsDimension,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.DmsDimension>
